import { inputToFloat } from "utils/calcs";
import { checkTruthyValue, INVALID_RESPONSE_MSG } from "utils/validation";
import * as Yup from "yup";

const hasTrimmedText = (v: unknown) => v != null && String(v).trim() !== "";

/** Match FormInputCurrency / API values that may include commas or £. */
const isParsableNumber = (v: unknown) => {
  if (v === "" || v == null) return false;
  const n = inputToFloat(v);
  if (typeof n === "number") return !Number.isNaN(n);
  if (typeof n === "string" && n.trim() === "") return false;
  const parsed = Number(String(n).replace(/,/g, "").replace(/\s/g, ""));
  return !Number.isNaN(parsed);
};

const isCompleteCreditProviderRow = (row: unknown): boolean => {
  if (!row || typeof row !== "object") return false;
  const { providerType, balanceOutstanding, settlementAmount, monthlyPayment } =
    row as Record<string, unknown>;
  return (
    hasTrimmedText(providerType) &&
    isParsableNumber(balanceOutstanding) &&
    isParsableNumber(settlementAmount) &&
    isParsableNumber(monthlyPayment)
  );
};

const validation = Yup.object().shape({
  householdExpenditure: Yup.object().shape({
    futureChangeInExpenditure: Yup.bool()
      .required(INVALID_RESPONSE_MSG)
      .typeError(INVALID_RESPONSE_MSG),
    changeInExpenditureDetail: Yup.string().when("futureChangeInExpenditure", {
      is: (value: any) => checkTruthyValue(value),
      then: () => Yup.string().required(INVALID_RESPONSE_MSG),
      otherwise: () => Yup.string().nullable(),
    }),
  }),
  applicantCredit: Yup.array().of(
    Yup.object().shape({
      applicantHasOutstandingCredit: Yup.bool()
        .required(INVALID_RESPONSE_MSG)
        .typeError(INVALID_RESPONSE_MSG),
      creditProviders: Yup.array().when("applicantHasOutstandingCredit", {
        is: (value: any) => checkTruthyValue(value),
        then: (schema) =>
          schema
            .min(
              1,
              "Please provide the details for the Applicants outstanding credit",
            )
            .test(
              "credit-provider-rows-complete",
              "Please ensure Type, Balance Outstanding, Settlement Amount and Monthly Payment are provided for each credit provider",
              (rows) => {
                if (!rows?.length) {
                  return true;
                }
                return rows.every((row) => isCompleteCreditProviderRow(row));
              },
            ),
        otherwise: () => Yup.array().nullable(),
      }),
    }),
  ),
});

export default validation;
